import React from 'react';
import classNames from 'classnames';
import { Modal } from 'reactstrap';
import PropTypes from 'prop-types';
import { ThemeProps } from '../../../../shared/prop-types/ReducerProps';
import ItemEditModalForm from './ItemEditModalForm';

const EditMasterCatalogModal = ({
  changeShowEditModal, showEditModal, theme, selectedData, setForceRefresh, budgetGroupOptions, setShowEditModal, retailerConfig,
}) => {
  const modalClasses = classNames({
    'todo__add-modal': true,
  }, theme.className, 'ltr-support');

  return (
    <Modal
      isOpen={showEditModal}
      toggle={changeShowEditModal}
      className={modalClasses}
    >
      <ItemEditModalForm
        changeShowEditModal={changeShowEditModal}
        selectedData={selectedData}
        setForceRefresh={setForceRefresh}
        budgetGroupOptions={budgetGroupOptions}
        setShowEditModal={setShowEditModal}
        retailerConfig={retailerConfig}
      />
    </Modal>
  );
};

EditMasterCatalogModal.propTypes = {
  changeShowEditModal: PropTypes.func.isRequired,
  showEditModal: PropTypes.bool.isRequired,
  theme: ThemeProps.isRequired,
};


export default EditMasterCatalogModal;
